// extracted by mini-css-extract-plugin
module.exports = {"body":"sQY-LTTn"};